import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Logo from "../assets/images/Logo.png";
import MyHeader from "../Components/MyHeader";

function UserPermissions(props) {
  return (
    <>
      <MyHeader />
      <Stack className="container">
        <LogoDiv>
          <LogoImg style={{ backgroundImage: `url(${Logo})` }}></LogoImg>
        </LogoDiv>

        <WhiteRect className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
            <hr className="my-4 w-50 mx-auto" />
            <LoremIpsum className="text-center">
              User Permissions / Hardware not Found
            </LoremIpsum>
            <Caption className="pb-2">
              <b>Try:</b>
            </Caption>
            <ul>
              <Caption>
                <li>Check your device camera and microphone hardware.</li>
              </Caption>
              <Caption>
                <li>Go to wepage settings >> allow required permissions.</li>
              </Caption>
              <Caption>
                <li>Try with different device, if possible.</li>
              </Caption>
            </ul>

            <hr className="my-4 w-50 mx-auto" />
            <p className="px-5 text-center">
              <Link style={{ textDecoration: "none" }} to="/">
                <LoremIpsum3>
                  {" "}
                  <b>Try Again</b>
                </LoremIpsum3>
              </Link>
            </p>
          </div>
          <div className="col-md-2"></div>
        </WhiteRect>
      </Stack>
    </>
  );
}

const Stack = styled.div`
flex-grow: 1
  background-color: rgba(255, 255, 255, 1);
`;

const WhiteRect = styled.div``;

const LoremIpsum = styled.p`
  font-family: Montserrat;
  font-style: normal;
  font-weight: 700;
  color: #2ba049;
  width: auto;
  padding-right: 48px;
  padding-left: 48px;
  padding-bottom: 24px;
  line-height: 24px;
  margin: 0;
`;

const Caption = styled.p`
  font-family: Montserrat;
  font-style: normal;
  width: auto;
  padding-right: 48px;
  padding-left: 48px;
  font-size: 0.75rem;
  margin: 0;
`;

const LoremIpsum3 = styled.span`
  font-family: Montserrat;
  font-style: normal;
  color: #2ba049;
  width: auto;
  text-align: center;
  line-height: 20px;
  font-size: 0.75rem;
  margin: 0;
`;

const LogoDiv = styled.div`
  padding: 24px;
`;

const LogoImg = styled.div`
  height: 80px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

export default UserPermissions;
